import { SearchInput } from "@/components/atoms";
import { useGetInvoicesCompaniesParams } from "../hooks";
import { usePagination } from "@/hooks";

export const InvoicesCompaniesSearch = () => {
  const { search, setSearch } = useGetInvoicesCompaniesParams();
  const { clearPagination } = usePagination("invoices");
  
  const handleSearch = (value?: string) => {
    clearPagination();
    setSearch(value);
  };

  return <SearchInput search={search} onSearch={handleSearch} placeholder="Search..." size="md" />;
};
